import { render } from "./UsersStats.vue?vue&type=template&id=5e448322"
import script from "./UsersStats.vue?vue&type=script&lang=js"
export * from "./UsersStats.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__